/**
 * URL do app principal (MAM Control) a partir do M-Panel.
 * Produção: mesmo domínio na raiz. Dev: VITE_APP_URL ou localhost:5173.
 */
export function resolveMainAppUrl() {
  const configured = import.meta.env.VITE_APP_URL
  if (configured) {
    return String(configured).replace(/\/$/, '')
  }

  const { origin, port } = window.location
  if (port === '5174') {
    return `${origin.replace(':5174', '')}:5173`
  }

  return origin
}
